.loginPage, .signup, .forgotPassword, .forgotPassword {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}
.loginHeading {
  font-size: 1.5rem;
  line-height: 1.5rem;
  letter-spacing: 0.006rem;
  font-family: "Poppins", sans-serif;
  margin-bottom: 2.5rem;
  margin-top: 0rem;
  color: #243460;
}
.loginHeading + p {
  font-family: "Poppins", sans-serif;
  margin-bottom: 2.813rem;
  line-height: 1.5rem;
  margin-top: 1rem;
  color: #243460;
}
.container {
  max-width: 90rem;
  margin: auto;
  min-height: 70vh;
  font-family: "Poppins", sans-serif;
}

.headerMobile {
  padding: 1rem;
}

/*.logoLight img {
  width: 9.375rem;
}*/

.primaryBtn {
  padding: 0.5rem 0.75rem;
  background: #243460;
  color: #ffffff;
  border-radius: 0.125rem;
  font-weight: 600;
  border: 0.125rem solid #243460;
  transition: 0.5s all;
  border-radius: 0.375rem;
}

.primaryBtn:hover {
  border-color: #FE7165;
}

.signUpBtn {
  font-size: 0.875rem;
  padding: 0.5rem 3.75rem;
}
.signUpText {
  font-size: 0.875rem;
  text-align: center;
  font-size: 0.875rem;
  line-height: 1.75rem;
  color: #243060;
  font-weight: 600;
  margin-right: 1.25rem;
}
.signUpText:hover {
  color: #FE7165;
}
.leftContent {
  border-top-right-radius: 6.25rem;
}

.formContainer {
  padding: 1rem;
}
.content {
  padding: 2.5rem 1rem;
}
.seperatorLine {
  flex: 1;
  height: 0.063rem;
  background-color: #243460;
}

.seperatorText {
  padding: 0rem 2.375rem;
  color: #3b3b3b;
  font-weight: 400;
  font-size: 1rem;
}

.loginForm input {
  color: #3B3B3B;
  padding: 0.625rem 0.75rem;
  border-radius: 0rem;
  background-color: #ffffff;
  outline: none;
  font-family: "Poppins", sans-serif;
  margin-top: 0.625rem;
  border: 0.063rem solid #24346066;
  font-size: 0.75rem;
  line-height: 1rem;
  letter-spacing: 0.031rem;
  font-weight: 500;
  text-align: justify;
  border-radius: 0.375rem;
}
.loginForm input::placeholder {
  color: #3B3B3B99;
  font-weight: 300;
}
.loginForm input:hover {
  border-color: #243460;
}
.loginForm input:active, .loginForm input:focus {
  border-color: #243460;
  border-width: 0.094rem;
  padding: 0.594rem 0.75rem;
}
.loginForm label {
  color: #3b3b3b;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.25rem;
  letter-spacing: 0.006rem;
  font-family: "Poppins", sans-serif;
}
.loginForm label:hover ~ input {
  border: 0.063rem solid #24346066;
}
label.errorLabels {
  color: #FF0000;
  font-size: 0.75rem;
  margin-top: 0.25rem;
  opacity: 70%;
  line-height: 1rem;
  letter-spacing: 0.031rem;
  font-weight: 400;
  font-family: "Poppins", sans-serif;
  opacity: 1;
}

.loginForm label.errorLabelForm {
  color: #FF0000;
  font-size: 0.875rem;
  margin-left: 0.25rem;
  opacity: 1;
}

.emailRow,
.passwordRow,
.rememberMeRow {
  margin-bottom: 1.5rem;
}
.passwordEye svg {
  width: 1.25rem !important;
}

.loginForm input:focus {
  outline: none;
}

.loginBtn {
  font-family: "Poppins", sans-serif;
  width: 100%;
  cursor: pointer;
  padding: 1.063rem;
  font-size: 0.875rem;
  line-height: 1.125rem;
  font-weight: 500;
  color: #ffffff;
  margin-bottom: 0.5rem;
  margin-top: 0.5rem;
  text-transform: uppercase;
}
.socialSection {
  margin: auto;
  margin-top: 1.375rem;
}
.socialIcons {
  width: 2.5rem;
  height: 2.5rem;
  cursor: pointer;
}
.contentContaienr {
  width: 100%;
  flex-grow: 1;
}
.content {
  flex: 1;
  max-width: 100%;
}
.formContainer {
  width: 100%;
  max-width: 29.5rem;
  margin: 0 auto;
}

.contentContaienr .leftContent {
  background-color: #243460;
  position: relative;
  width: 42.2%;
}
.leftContent img {
  position: absolute;
  bottom: 0;
  right: 0;
  width: 80%;
  z-index: 1;
}

.desktopHeader {
  position: relative;
  height: 6.25rem;
}
.dontHaveAccount {
  color: #3b3b3b;
  font-weight: 600;
  font-size: 0.875rem;
  margin-right: 1.25rem;
  cursor: pointer;
}
.footer {
  background-color: #243460;
  padding: 2rem 1rem;
  color: white;
}
.footerText {
  font-size: 0.75rem;
}
.footerLogo img {
  width: 12.5rem;
}

.heading {
  font-weight: 600;
  font-size: 1.5rem;
  font-family: "Poppins", sans-serif;
  color: #243460;
}
.subHeading {
  font-size: 1rem;
  font-weight: 400;
  font-family: "Poppins", sans-serif;
  line-height: 1.5rem;
  margin-bottom: 2.75rem;
  color: #243460;
}
.normalLink {
  color: #243460;
}
.normalLink:hover {
  color: #FE7165;
  text-decoration: none;
}
.leftContent img {
  width: 100%;
  height: 80%;
  position: absolute;
  bottom: 0;
  right: 0;
  object-fit: cover;
}
.logoDark img {
  position: absolute;
  left: 2.5rem;
  top: 50%;
  transform: translateY(-50%);
  max-width: 12.5rem;
  object-fit: contain;
  height: auto;
}
@media screen and (min-width: 46.5rem) {
  .footerLogo img {
    width: 9.375rem;
  }
  .leftContent {
    max-height: 100%;
  }
  .contentContaienr {
    width: 100%;
  }
  .desktopHeader {
    height: 6.25rem;
    padding-right: 2rem;
  }

  .content {
    padding: 0rem 0rem 1.25rem 0rem;
  }
  .leftContent {
    width: 40%;
  }
}
@media screen and (max-width: 46.5rem) {
  .signUpBtn {
    padding: 0.5rem 1.75rem;
  }
}
.inputMessage {
  font-size: 0.875rem;
  margin-top: 0.625rem;
  color: #000000;
}


@media screen and (min-width: 64.25rem) {
}

@media screen and (min-width: 80rem) {
  .leftContent {
    width: 50%;
  }
}
@media screen and (max-width: 79.938rem) {
  .leftContent img {
    object-fit: fill;
    min-height: unset;
    max-height: 80%;
    position: absolute;
    bottom: 0;
    right: 0;
    width: 100%;
    height: auto;
}
}

.nopadding {
  padding: 0;
}

.iframecontainer {
  padding-top: 0.625rem;
  max-width: 28.125rem;
  margin: 0 auto;
}
.iframecontainer {
  width: 90%;
  max-width: 100%;
}
@media screen and (max-width: 64rem) {
  .contentContaienr .leftContent {
    width: 34%;
  }
  .formContainer {
    padding: 1rem 1.25rem;
}
.loginForm input {
  margin-top: 0.5rem;
  padding: 0.688rem 0.75rem;
}
}
@media screen and (max-width: 37.5rem) {
  .logoLight {
    width: 1.875rem;
    height: 2.5rem;
  }
  .formContainer {
    margin: 0 auto;
  }
  .content {
    padding: 2.875rem 0rem;;
  }
  .formContainer {
    width: 100%;
    padding: 1rem;
    margin: 0 auto;
  }
  .iframecontainer {
    padding:0
  }
  .loginForm input {
    padding: 0.688rem 0.563rem;
}
}
